import { getMovementsByMonthReport } from '../services/ReportsService';
import { exportMovementsByMonthReport } from '../services/ExportService';
import TableContainer from '../components/table/TableContainer';
import { formatCurrency } from '../utils/numbers';
import { reverseMonthYear } from '../utils/dates';

const ReportMovementsByMonth = () => {
    // ----- Constants
    const columns = [
        {
            name: 'Periodo',
            selector: (row) => reverseMonthYear(row.timePeriod),
            width: '90px',
        },
        {
            name: 'Saldo Inicial',
            selector: (row) => `₡${formatCurrency(row.initialBalance)}`,
        },
        {
            name: 'Compras',
            selector: (row) => `₡${formatCurrency(row.totalReceipts)}`,
        },
        {
            name: 'Despachos',
            selector: (row) => `₡${formatCurrency(row.totalIssues)}`,
        },
        {
            name: 'Compras Fuera de Rango',
            selector: (row) => `₡${formatCurrency(row.totalReceiptsOutOfRange)}`,
        },
        {
            name: 'Despachos Fuera de Rango',
            selector: (row) => `₡${formatCurrency(row.totalIssuesOutOfRange)}`,
        },
        {
            name: 'Monto IVA',
            selector: (row) => `₡${formatCurrency(row.totalReceiptsTax)}`,
        },
        {
            name: 'Saldo Final',
            selector: (row) => `₡${formatCurrency(row.finalBalance)}`,
        },
    ];

    const exportOptions = {
        handler: exportMovementsByMonthReport,
    };

    const filters = [
        {
            label: 'Periodo de tiempo',
            column: 'timePeriod',
            input: 'month-year',
            operation: 'between',
        },
    ];

    // ----- Render
    return (
        <div className='container mt-5'>
            <h1 className='mb-5'>Reporte Consolidado de Compras y Despachos</h1>

            <TableContainer
                columns={columns}
                defaultSort={'timePeriod'}
                fetchDataHandler={getMovementsByMonthReport}
                updateTable={true}
                filters={filters}
                exportOptions={exportOptions}
            />
        </div>
    );
};

export default ReportMovementsByMonth;
